import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=8cdab2e2&scoped=true&"
import script from "./ListItem.vue?vue&type=script&lang=ts&"
export * from "./ListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ListItem.vue?vue&type=style&index=0&id=8cdab2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdab2e2",
  null
  
)

export default component.exports